import { ResourceType } from 'domains/models/user_resource_set_detail/resourceType';
import { z } from 'zod';

export const ResourceTypeEnum = z.nativeEnum(ResourceType);
